"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthInterceptor = void 0;
const RequestInterceptor_1 = require("./RequestInterceptor");
class AuthInterceptor extends RequestInterceptor_1.RequestInterceptor {
    constructor(accessTokenProvider, authStatusManager, axios) {
        super(axios);
        this.accessTokenProvider = accessTokenProvider;
        this.authStatusManager = authStatusManager;
        this.accessTokenProvider = accessTokenProvider;
        this.authStatusManager = authStatusManager;
    }
    onFulfilled(config) {
        return __awaiter(this, void 0, void 0, function* () {
            const accessToken = yield this.accessTokenProvider.getAccessToken();
            const validToken = yield accessToken.get(() => __awaiter(this, void 0, void 0, function* () {
                yield this.authStatusManager.logoutUser();
            }));
            if (!validToken) {
                return this.rejectRequest(config, "No valid authentication token available", "FORCE_LOGOUT");
            }
            config.headers = config.headers.set("Authorization", `Bearer ${validToken}`);
            return config;
        });
    }
}
exports.AuthInterceptor = AuthInterceptor;
